"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        width: 550,
        '&[data-is-bottom-margin=true]': {
            marginBottom: 30
        }
    },
    styledDiv: {
        color: '#333333',
        fontSize: 18,
        weight: 'bolder',
        marginBottom: 10
    }
};
//# sourceMappingURL=fieldTemplate.style.js.map